/**
 * SourceBlock — 根拠・出典ブロック (FR-18, 一級市民)
 * 解説/テキストに常設。免責文も常設（#68 合否断定回避）。
 */

import Icon from './Icon'

interface SourceBlockProps {
  sourceLaw?: string | null
  sourceReference?: string | null
  confirmedDate?: string | null
  lawRevisionDate?: string | null
  /** 模試結果など「合否目安」表記のある画面で使用 */
  showExamDisclaimer?: boolean
}

export default function SourceBlock({
  sourceLaw,
  sourceReference,
  confirmedDate,
  lawRevisionDate,
  showExamDisclaimer = false,
}: SourceBlockProps) {
  return (
    <div
      data-testid="source-block"
      className="mt-4 rounded-md bg-surface-alt px-3.5 py-3 text-xs leading-relaxed text-text-secondary"
    >
      <div className="mb-1.5 flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide text-text-muted">
        <Icon name="info" size={12} />
        根拠・出典
      </div>
      {sourceLaw && (
        <div>
          <span className="font-semibold text-text-primary">根拠法令:</span> {sourceLaw}
        </div>
      )}
      {sourceReference && (
        <div>
          <span className="font-semibold text-text-primary">出典:</span> {sourceReference}
          {confirmedDate && <span className="ml-1.5 text-text-muted">（確認日 {confirmedDate}）</span>}
        </div>
      )}
      {lawRevisionDate && (
        <div className="mt-1">
          <span className="font-semibold text-text-primary">法令改正日:</span> {lawRevisionDate}
        </div>
      )}
      <div className="mt-2 border-t border-border pt-1.5 text-[11px] text-text-muted">
        ※ 最終確認は公式テキスト・最新法令をご参照ください
      </div>
      {showExamDisclaimer && (
        <div className="mt-1 text-[11px] text-text-muted">
          ※ 結果は合否目安です。実際の試験の合否を保証するものではありません
        </div>
      )}
    </div>
  )
}
